export class OrcamentoParcelaDataVencimento {
  orcamento: any;
  dataVencimento: any;
}
